import { render, staticRenderFns } from "./index.vue?vue&type=template&id=469e7c67&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLink: require('/home/vsts/work/1/a/NuxtApp/components/base/Link.vue').default,BaseIcon: require('/home/vsts/work/1/a/NuxtApp/components/base/Icon.vue').default,BaseCollapseTransition: require('/home/vsts/work/1/a/NuxtApp/components/base/CollapseTransition.vue').default,BaseToggle: require('/home/vsts/work/1/a/NuxtApp/components/base/Toggle.vue').default,AppUSP: require('/home/vsts/work/1/a/NuxtApp/components/app/USP.vue').default})
